import './index.css';
import { customerCallBgIcon } from '../../assets';
import AgoraRTC from 'agora-rtc-sdk-ng';
import { useEffect, useRef, useState } from 'react';
import CallStore from '../../stores/CallStore';
import { useLocation, useParams } from 'react-router';
import SocketStore from '../../stores/SocketStore';
import ShapesContainer from '../Shapes';
import { useContext } from 'react';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import { getUrlValue } from '../../helpers/functions';
import { observer } from 'mobx-react';
import CustomerCallBottom from '../CustomerCallBottom';
import strings from '../../localization';

// const APP_ID = "c7ea31f2517e44ab80fc51321b46c00d";
const APP_ID = "ed4c0ffd56054721a1b4cd90e0cf0dfd";

const NoConnectionContainer = ({ isPermissionGranted, setIsPermissionGranted }) => {
  const params = useParams();
  const query = useLocation();


  const { showModalAlert, closeModalAlert, showPleaseWait } = useContext(ModalAlertContext);

  const requestPermission = () => {
    const tryGetMedia = (constraints) => navigator.mediaDevices.getUserMedia(constraints);

    tryGetMedia({ video: { facingMode: { ideal: 'environment' } }, audio: true })
      .catch(() => tryGetMedia({ video: { facingMode: { ideal: 'user' } }, audio: true }))
      .catch(() => tryGetMedia({ video: true, audio: true }))
      .then((stream) => {
        stream.getTracks().forEach((t) => t.stop());
        setIsPermissionGranted(true);
      })
      .catch((error) => {
        showModalAlert({
          title: strings.error, message: strings.pleaseGrantPermissionInSettingsToUseCameraAndMicrophone, confirmText: strings.ok, onConfirm: () => {
            closeModalAlert();
          }, onCancel: null
        });
        setIsPermissionGranted(false);
      });
  }


  useEffect(() => {
    showPleaseWait({ title: strings.pleaseWait, message: strings.informationAndConnectionAreBeingChecked });
    if (!isPermissionGranted) {
      requestPermission();
    }
    else {
      const pin = getUrlValue(query.search, "pin");
      const slug = params.slug;
      CallStore.setSlug(slug);

      SocketStore.connectCustomerSocket(slug, pin);
    }
  }, [isPermissionGranted]);

  return (
    <div className="customer-call-container-no-connection">
      <img src={customerCallBgIcon} alt="customer-call-bg" />
    </div>
  );
};

const createCameraVideoTrack = async (i = 0) => {

  // const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: "environment" } }, audio: true })
  // stream.getTracks()
  //   .forEach(track => {

  //     track.stop()
  //   });

  const facingModes = ["environment", "user"];
  var _localTrack;

  try {
    const localTrack = await AgoraRTC.createCameraVideoTrack({
      facingMode: facingModes[i], // Ön kamera
      mirror: false,
    })
    _localTrack = localTrack;

  } catch (error) {
  }
  if (_localTrack) {
    return _localTrack;
  }
  else {
    return await createCameraVideoTrack(i + 1);
  }
}

const CustomerCallContainer = ({ handleChatIsOpen, chatIsOpen, setChatIsOpen, setClient }) => {
  const localVideoRef = useRef(null);
  const [error, setError] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isPermissionGranted, setIsPermissionGranted] = useState(false);
  const { closePleaseWait } = useContext(ModalAlertContext);



  const client = AgoraRTC.createClient({
    mode: 'rtc',
    codec: 'vp8',
    audioTrack: true,
    videoTrack: true,
  });

  let localTrack;
  const [localVideoTrack, setLocalVideoTrack] = useState(null);
  const [localAudioTrack, setLocalAudioTrack] = useState(null);
  const [remoteAudioTrack, setRemoteAudioTrack] = useState(null);


  async function emitAudioTrack() {
    // Create audio track
    const microphones = await AgoraRTC.getMicrophones();
    var _localAudioTrack;
    if (microphones.length > 0) {
      _localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
        microphoneId: microphones[0].deviceId,
      });
      setLocalAudioTrack(_localAudioTrack);
    } else {
      // Fallback for audio if no specific microphone found
      _localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();

      setLocalAudioTrack(_localAudioTrack);
    }

    await client.publish([_localAudioTrack]);

  }

  useEffect(() => {
    if (!isConnected) {
      const token = CallStore.getCustomerCallToken();

      if (token) {
        start(token, CallStore.slug);
        SocketStore.setCustomerConnected(true);
        setClient(client);
      }
    }
  }, [CallStore.customerCallToken]);

  useEffect(() => {
    if (isConnected) {
      closePleaseWait();
    }
  }, [isConnected]);


  async function start(callToken, slug) {

    try {
      setError(null);

      const token = callToken || null;
      const uid = 1001;

      await client.join(APP_ID, slug, token, uid);
      SocketStore.sendCustomerResolution();
      setError(null);

      try {

        localTrack = await createCameraVideoTrack();

        if (localTrack) {
          try {
            localTrack.play(localVideoRef.current, { mirror: false });
            setLocalVideoTrack(localTrack);
          } catch (playError) {
            console.error('Video track play error:', playError);
            // Try to close and recreate the track
            localTrack.close();
            throw new Error('Video track oynatılamadı. Lütfen sayfayı yenileyin.');
          }
        }

        await emitAudioTrack();




        await client.publish([localTrack]);
        setIsConnected(true);
      } catch (trackError) {
        console.error('Video track oluşturma hatası:', trackError);
        setError(`Kamera erişimi hatası: ${trackError.message}`);
        return;
      }

    } catch (error) {
      console.error('Agora başlatma hatası:', error);
      setError(`Başlatma hatası: ${error.message}`);

      // Token hatası ise, token olmadan tekrar dene
      if (error.message.includes('token') || error.message.includes('gateway') || error.message.includes('OPERATION_ABORTED')) {
        try {
          await client.join(APP_ID, slug, null, new Date().getTime().toString());
          setIsConnected(true);
          setError(null);
        } catch (retryError) {
          console.error('Token olmadan da bağlantı başarısız:', retryError);
          setError(`Bağlantı başarısız: ${retryError.message}`);
        }
      }
    } finally {
    }
  }

  const endCallViaAgora = async () => {
    try {

      await client?.leave();
      localVideoTrack.stop();
      localAudioTrack.stop();
      localVideoTrack.close();
      localAudioTrack.close();
      setLocalVideoTrack(null);
      setLocalAudioTrack(null);

    } catch (error) {
      console.error('Agora başlatma hatası:', error);
    }

  }

  useEffect(() => {

  }, []);


  useEffect(() => {
    client.on('user-published', async (user, mediaType) => {
      try {
        await client.subscribe(user, mediaType);

        if (mediaType === 'audio') {
          const _remoteAudioTrack = user.audioTrack;
          setRemoteAudioTrack(_remoteAudioTrack);
          _remoteAudioTrack.play(document.createElement('div'), { autoPlay: true });
        }
      } catch (subscribeError) {
        console.error('Uzak kullanıcıya abone olma hatası:', subscribeError);
      }
    });


    client.on('user-unpublished', (user) => {
    });

    client.on('user-joined', async (user) => {
      await emitAudioTrack();
    });

    client.on('user-left', (user) => {
    });

    client.on('error', (err) => {
      console.error('Agora client hatası:', err);
      setError(`Bağlantı hatası: ${err.message}`);
    });

    client.on('connection-state-change', (curState, prevState) => {
    });
  }, [client]);

  return (
    <div className="customer-call-container">
      {!isConnected &&
        <NoConnectionContainer
          isPermissionGranted={isPermissionGranted}
          setIsPermissionGranted={setIsPermissionGranted}
        />}
      <div
        ref={localVideoRef}
        style={{
          width: '100%',
          height: '100%',
          visibility: isConnected ? 'visible' : 'hidden',
          overflow: 'hidden',
        }}
      />
      <ShapesContainer visibility={isConnected ? 'visible' : 'hidden'} />

      <CustomerCallBottom
        handleChatIsOpen={handleChatIsOpen}
        localAudioTrack={localAudioTrack}
        remoteAudioTrack={remoteAudioTrack}
        chatIsOpen={chatIsOpen}
        endCallViaAgora={endCallViaAgora}
        localVideoTrack={localVideoTrack}
        setChatIsOpen={setChatIsOpen}
      />
    </div >
  );
}


export default observer(CustomerCallContainer);